import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  full_name: string | null;
  avatar_url: string | null;
  phone: string | null;
  role: 'user' | 'admin';
  created_at: string;
};

// Actualizamos los tipos de estado
export type ListingStatus = 'pending' | 'approved' | 'rejected' | 'rented' | 'sold';

export type Listing = {
  id: string;
  user_id: string;
  title: string;
  description: string | null;
  price: number;
  operation_type: 'rent' | 'sale';
  
  // Ubicación
  address: string | null;
  city: string;
  province: string | null;
  postal_code: string | null;
  
  // Dimensiones
  area_m2: number;
  height_m?: number;
  volume_m3?: number;

  // Económico
  expenses_included?: boolean;
  community_fee?: number;
  ibi?: number;

  // Disponibilidad
  available_from?: string;
  min_months?: number;

  images: string[];
  features: Record<string, boolean>;
  is_active: boolean;
  status: ListingStatus;
  
  contact_name?: string;
  contact_email?: string;
  contact_phone?: string;
  view_count?: number;
  created_at: string;
};

export type MessageReply = {
  id: string;
  message_id: string;
  reply_message: string;
  created_at: string;
};

export type Message = {
  id: string;
  storage_id: string;
  sender_id: string | null;
  owner_id: string;
  sender_email: string;
  sender_name: string;
  sender_phone: string | null;
  message: string;
  is_read: boolean;
  created_at: string;
  listings?: {
    title: string;
  } | null;
  message_replies?: MessageReply[];
};

// --- BLOG TYPES ---

export type BlogCategory = {
  id: string;
  name: string;
  slug: string;
  description?: string;
  created_at: string;
};

export type BlogPost = {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  image_url?: string;
  status: 'draft' | 'published' | 'archived';
  published_at?: string;
  category_id?: string;
  author_id: string;
  is_featured?: boolean; // NUEVO CAMPO
  
  // SEO Fields
  meta_title?: string;
  meta_description?: string;
  keywords?: string[];
  
  // Analytics
  view_count: number;
  
  created_at: string;
  categories?: BlogCategory; // Join
};
